import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DasSenseHSvgColorMedium = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4014 15.0742C14.7175 15.0743 16.7837 15.9974 18.1406 17.7432C16.715 18.624 15.7656 20.2011 15.7656 22C15.7656 22.395 15.8128 22.7789 15.8994 23.1475H5C5.00021 17.9455 8.31401 15.0742 12.4014 15.0742ZM12.4014 7C14.2592 7.00017 15.7656 8.50644 15.7656 10.3643C15.7656 12.2221 14.2592 13.7283 12.4014 13.7285C10.5434 13.7285 9.03711 12.2222 9.03711 10.3643C9.03714 8.50634 10.5434 7 12.4014 7Z"
        fill="#FFB905"
      />
      <mask id="path-2-inside-1_7198_7201" fill="white">
        <path d="M21 4C23.2091 4 25 5.79086 25 8V17.5283C26.2273 18.627 27 20.2231 27 22C27 25.3137 24.3137 28 21 28C17.6863 28 15 25.3137 15 22C15 20.2231 15.7727 18.627 17 17.5283V8C17 5.79086 18.7909 4 21 4Z" />
      </mask>
      <path
        d="M21 4C23.2091 4 25 5.79086 25 8V17.5283C26.2273 18.627 27 20.2231 27 22C27 25.3137 24.3137 28 21 28C17.6863 28 15 25.3137 15 22C15 20.2231 15.7727 18.627 17 17.5283V8C17 5.79086 18.7909 4 21 4Z"
        fill="#F3F3F3"
      />
      <path
        d="M25 8H26.5H25ZM25 17.5283H23.5V18.1988L23.9996 18.646L25 17.5283ZM17 17.5283L18.0004 18.646L18.5 18.1988V17.5283H17ZM21 4V5.5C22.3807 5.5 23.5 6.61929 23.5 8H25H26.5C26.5 4.96243 24.0376 2.5 21 2.5V4ZM25 8H23.5V17.5283H25H26.5V8H25ZM25 17.5283L23.9996 18.646C24.9226 19.4722 25.5 20.6677 25.5 22H27H28.5C28.5 19.7785 27.532 17.7817 26.0004 16.4107L25 17.5283ZM27 22H25.5C25.5 24.4853 23.4853 26.5 21 26.5V28V29.5C25.1421 29.5 28.5 26.1421 28.5 22H27ZM21 28V26.5C18.5147 26.5 16.5 24.4853 16.5 22H15H13.5C13.5 26.1421 16.8579 29.5 21 29.5V28ZM15 22H16.5C16.5 20.6677 17.0774 19.4722 18.0004 18.646L17 17.5283L15.9996 16.4107C14.468 17.7817 13.5 19.7785 13.5 22H15ZM17 17.5283H18.5V8H17H15.5V17.5283H17ZM17 8H18.5C18.5 6.61929 19.6193 5.5 21 5.5V4V2.5C17.9624 2.5 15.5 4.96243 15.5 8H17Z"
        fill="#A1A1A1"
        mask="url(#path-2-inside-1_7198_7201)"
      />
      <path
        d="M21 10C21.5523 10 22 10.4477 22 11V19.1738C23.1647 19.5859 24 20.6942 24 22C24 23.6568 22.6568 25 21 25C19.3432 25 18 23.6568 18 22C18 20.6942 18.8353 19.5859 20 19.1738V11C20 10.4477 20.4477 10 21 10Z"
        fill="#FF6B00"
      />
    </SvgIcon>
  );
};

export default DasSenseHSvgColorMedium;
